import React, { useState } from "react";
import "./Navbar55.css";
import { Link } from "react-router-dom";
// import logo from "../../../public/assets/imagesnew/Navbar/logo.png";

const Navbar55 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg MainNavbar"
        aria-label="Fifth navbar example"
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img className="w-100 h-100" src="assets/imagesnew/Navbar/logo.png" alt="" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarsExample05"
            aria-controls="navbarsExample05"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
          <span>  <i className="fa fa-bars" aria-hidden="true"></i></span>

          </button>
          <div className="collapse navbar-collapse" id="navbarsExample05">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0 gap-4">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="/">
                    Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#About">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#Blog">
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#Contact">
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link blink-button" href="https://crmuser.a2zfx.trade/en/login">
                  Client login
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link blink-button" href="https://ib.a2zfx.trade/login">
                Partner login
                </a>
              </li>
            </ul>
            <div className="d-flex flex-wrap align-items-center gap-2 buttongroup mx-3 mt-3 mt-lg-0">
              <a href="/login" className="btn">Login</a>
              <a href="/register" className="btn">Sign Up</a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar55;
